// This file is auto-generated - DO NOT EDIT - it will be overwritten. 

export const apiEndpoints = {
	app:{
		getappuser: "api/app/appuser",
		getlanguagesaskey: "api/app/translationSasToken",
	},
	assembly:{
		getassemblydetails: "api/assembly/assembly/{regnr}",
		listdevices: "api/assembly/device/list",
	},
	attachment:{
		addattachment: "api/attachment/create/{feature}",
		deleteattachment: "api/attachment/delete/attachment/{fileid}",
		downloadattachment: "api/attachment/download/{fileId}",
		getattachments: "api/attachment/get/{fileid}/{feature}",
		updatelocizetranslations: "api/attachment/update-locize-translations/{version}/{languages}/{ns}",
	},
	checktemplate:{
		addvehiclestochecktemplate: "api/checktemplate/{checkTemplateId}/vehicles",
		calculatenextservicedates: "api/checktemplate/{checkTemplateId}/calculate",
		confirmservice: "api/checktemplate/confirm-service",
		createchecktemplate: "api/checktemplate/createchecktemplate",
		createchecktemplateinterval: "api/checktemplate/{checkTemplateId}/intervals",
		createinspectionbooking: "api/checktemplate/inspection/booking/create",
		deletechecktemplate: "api/checktemplate/{id}",
		deletechecktemplateinterval: "api/checktemplate/intervals/{id}",
		deleteinspectionbooking: "api/checktemplate/{checkTemplateId}/inspection/booking/{inspectionBookingId}/delete",
		getallupcomingchecks: "api/checktemplate/upcoming/all",
		getcategorizedinspections: "api/checktemplate/upcoming/inspections/categorized/{daysAhead}",
		getchecktemplate: "api/checktemplate/{id}",
		getchecktemplateintervals: "api/checktemplate/{checkTemplateId}/intervals",
		getchecktemplatelist: "api/checktemplate/getchecktemplatelist",
		getchecktemplatevehicles: "api/checktemplate/{checkTemplateId}/vehicles",
		getinspectionforbooking: "api/checktemplate/{checkTemplateId}/vehicle/{vehicleId}/inspection/booking",
		getoverdueservices: "api/checktemplate/overdue",
		getserviceforconfirmation: "api/checktemplate/{checkTemplateId}/vehicle/{vehicleId}/service/confirmation",
		getservicestatistics: "api/checktemplate/statistics",
		getservicestatusforvehicle: "api/checktemplate/{checkTemplateId}/vehicles/{vehicleId}/status",
		getservicestatusforvehicles: "api/checktemplate/{checkTemplateId}/status",
		getsimpleupcominginspections: "api/checktemplate/upcoming/inspections/simple/{daysAhead}",
		getupcomingchecksforvehicle: "api/checktemplate/upcoming/vehicle/{vehicleId}",
		getvehicleservices: "api/checktemplate/{checkTemplateId}/vehicles/{vehicleId}/services",
		removevehiclefromchecktemplate: "api/checktemplate/{checkTemplateId}/vehicles/{vehicleId}",
		updatechecktemplate: "api/checktemplate/updatececktemplate",
		updatechecktemplateinterval: "api/checktemplate/intervals/{id}",
		updateinspectionbooking: "api/checktemplate/inspection/booking/update",
		updatevehicleservices: "api/checktemplate/updatevehicleservices",
	},
	clptableuserfilter:{
		get: "api/clptableuserfilter/get",
		upsert: "api/clptableuserfilter/upsert",
	},
	crisismanagement:{
		deleteattachment: "api/crisismanagement/attachment/delete/{id}",
		getattachment: "api/crisismanagement/crisisinfo/attachment/{id}",
		getattachmentthumbnailbyid: "api/crisismanagement/crisisinfo/attachment/thumbnail/{id}",
		getbloburl: "api/crisismanagement/crisisinfo/bloburl/{fileId}",
		getcrisisinfobycompanyid: "api/crisismanagement/crisisinfobycompanyId/{companyId}",
		updateattachment: "api/crisismanagement/attachment/update",
		uploadattachment: "api/crisismanagement/uploadattachment",
		uploadattachmenttocrisisinfo: "api/crisismanagement/upsertattachment/{companyId}",
		uploadbodyattachment: "api/crisismanagement/uploadbodyattachment",
		upsertcrisisinfo: "api/crisismanagement/crisisInfo",
	},
	customeradmin:{
		addcompany: "api/admin/settings/companies/add",
		addcustomercustomrole: "api/admin/settings/customer/role/add",
		adduser: "api/admin/settings/users/add",
		checkdepartmentconflicts: "api/admin/settings/companies/checkdepartmentconflicts",
		createorupdateuserrolestemplates: "api/admin/settings/role/templates/createorupdate",
		deletecompany: "api/admin/settings/companies/delete/{id}",
		deletecustomercustomrole: "api/admin/settings/customer/role/delete/{id}",
		deleteroletemplate: "api/admin/settings/role/templates/delete/{id}",
		deleteuser: "api/admin/settings/users/delete/{id}",
		getaduser: "api/admin/settings/users/aduser/{searchTerm}",
		getbpltypes: "api/admin/settings/user/bpltypes/{companyId}",
		getbpluserbyid: "api/admin/settings/users/getBplUser/{id}",
		getcompanieswithbplinstance: "api/admin/settings/users/companieswithbplinstance",
		getcompanybyid: "api/admin/settings/companies/get/{id}",
		getcustomer: "api/admin/settings/customer",
		getcustomeractiveusers: "api/admin/settings/users/listActive",
		getcustomercustomrolebyid: "api/admin/settings/customer/getrole/{id}",
		getcustomercustomroles: "api/admin/settings/customer/getroles",
		getcustomerexaminations: "api/admin/settings/customerexaminations",
		getcustomerlogobyname: "api/admin/settings/getcustomerlogobyname",
		getcustomerreporttemplates: "api/admin/settings/getcustomerreporttemplates",
		getcustomerusers: "api/admin/settings/users/list",
		getdisabledusers: "api/admin/settings/users/disabled",
		getemptyuser: "api/admin/settings/users/emptyuser",
		gethierarchymanagers: "api/admin/settings/users/hierarchymanagers",
		gettemplaterole: "api/admin/settings/role/template/get/{id}",
		getuserbyemail: "api/admin/settings/users/userbyemail/{email}",
		getuserbyid: "api/admin/settings/users/get/{id}",
		getuserroles: "api/admin/settings/role/get",
		getuserrolestemplates: "api/admin/settings/role/templates/get/{customerId}",
		getusersselectlistformanagerdropdown: "api/admin/settings/users/searchmanagers",
		getusersselectlistformanagerdropdownedit: "api/admin/settings/users/searchmanagersedit/{userId}",
		passwordreset: "api/admin/settings/users/resetpassword/{id}",
		updatecompany: "api/admin/settings/companies/update",
		updatecustomer: "api/admin/settings/customer",
		updatecustomercustomrole: "api/admin/settings/customer/role/update",
		updateuser: "api/admin/settings/users/update",
		uploadcustomerlogo: "api/admin/settings/uploadcustomerlogo",
	},
	dashboard:{
		getdriverongoingcases: "api/dashboard/driver/OngoingCases",
	},
	deviation:{
		adddeviation: "api/deviation/create",
		deletedeviation: "api/deviation/delete",
		deletedeviationattachment: "api/deviation/attachments/{id}",
		get: "api/deviation/get",
		getbyassignedid: "api/deviation/getassigned",
		getbyid: "api/deviation/get/{id}",
		getdeviationattachment: "api/deviation/attachment/{id}",
		getdeviationattachmentsbydeviationid: "api/deviation/attachments/list/{deviationId}",
		getdeviationexcel: "api/deviation/getexcel",
		getdeviationexceldate: "api/deviation/getexcel/dates",
		getfiltered: "api/deviation/getfiltered",
		getfilteredcompleted: "api/deviation/getfilteredcompleted",
		getfilteredtrafficlog: "api/deviation/trafficlog/getfiltered",
		getfilteredtrafficlogcompleted: "api/deviation/trafficlogcompleted/getfiltered",
		getfilteredvehicledamage: "api/deviation/vehicledamage/getfiltered",
		getfilteredvehicledamagecompleted: "api/deviation/vehicledamagecompleted/getfiltered",
		getfilteroptions: "api/deviation/getfilteroptions",
		getpaged: "api/deviation/getpaged",
		getpagedactive: "api/deviation/active/getpaged",
		getpagedcompleted: "api/deviation/completed/getpaged",
		getpagedtrafficlogactive: "api/deviation/trafficlogactive/getpaged",
		getpagedtrafficlogcompleted: "api/deviation/trafficlogcompleted/getpaged",
		getpagedvehicledamage: "api/deviation/vehicledamage/getpaged",
		getpagedvehicledamageactive: "api/deviation/vehicledamageactive/getpaged",
		getpagedvehicledamagecompleted: "api/deviation/vehicledamagecompleted/getpaged",
		gettotalassinged: "api/deviation/gettotalassigned",
		getusers: "api/deviation/getusers/{feature}",
		getvehicles: "api/deviation/getvehicles",
		senddeviationmail: "api/deviation/sendmail",
		updateattributes: "api/deviation/updateAttributes",
		updatedeviation: "api/deviation/update",
		upsertdeviationattachment: "api/deviation/attachments/upsert/{deviationId}",
	},
	documents:{
		adddocument: "api/documents/add",
		deleteattachment: "api/documents/attachment/delete/{id}",
		deletedocument: "api/documents/documents/delete/{id}",
		getattachment: "api/documents/document/attachment/{id}",
		getattachmentbyid: "api/documents/attachment/get/{id}",
		getbloburl: "api/documents/document/bloburl/{fileId}",
		getcustomercustomroles: "api/documents/document/getroles",
		getdocument: "api/documents/document/{id}/{companyId}",
		getsaskey: "api/documents/saskey",
		listfolders: "api/documents/list/{companyId}",
		listfoldersforstartpage: "api/documents/list/dashboard/{companyId}",
		updateattachment: "api/documents/attachment/update",
		updatedocument: "api/documents/update",
		uploadattachment: "api/documents/uploadattachment",
		uploadattachmenttodocument: "api/documents/upsertattachment",
	},
	form:{
		createorupdateformresult: "api/form/createorupdate/formresult",
		deleteformresult: "api/form/delete/formresult",
		getformansers: "api/form/list/formanswers/{formresultid}",
		getformresultbyid: "api/form/get/formresult/{id}/{formTemplate}",
		getformresults: "api/form/list/formresult",
		getformtemplate: "api/form/list/formtemplate/{feature}",
		getformtemplatebyid: "api/form/get/formtemplate/{id}",
		getformtemplateminimized: "api/form/list/formtemplatemini/{feature}",
		getformtemplatesminimized: "api/form/list/formtemplatemini",
		getvehiclelist: "api/form/get/vehicleslist",
		insertformtemplate: "api/form/createorupdate/formtemplate",
	},
	issuereportexternal:{
		declineworkorder: "api/workorder/declineworkorder",
		getcustomerlogobyname: "api/workorder/getcustomerlogobyname",
		getworkorderbyguid: "api/workorder/{guid}",
		sendworkorderbooking: "api/workorder/sendworkorderbooking",
		sendworkorderresolved: "api/workorder/sendworkorderresolved",
	},
	issuereportsadmin:{
		createissuereportcategory: "api/admin/issuereports/archive/categories/create",
		createworkorder: "api/admin/issuereports/workorders/create",
		deleteissuereport: "api/admin/issuereports/archive/issuereport/delete/{id}",
		deleteworkorder: "api/admin/issuereports/workorders/delete/{id}",
		getissuereportcategories: "api/admin/issuereports/categories",
		getissuereportcategorybyid: "api/admin/issuereports/archive/categories/{id}",
		getissuereportsarchive: "api/admin/issuereports/archive",
		getissuereportsbyvehicleid: "api/admin/issuereports/archive/issuereports/{vehicleId}",
		getissuereportsforworkorderbyvehicleid: "api/admin/issuereports/workorders/workorder/issuereports/{vehicleId}",
		getuserstoassign: "api/admin/issuereports/archive/issuereport/users",
		getvehicleswithworkissues: "api/admin/issuereports/workorders/workorder/vehicles",
		getworkorderdetails: "api/admin/issuereports/workorders/workorder/{id}",
		getworkorders: "api/admin/issuereports/workorders",
		sendworkorder: "api/admin/issuereports/workorders/send",
		updateissuereport: "api/admin/issuereports/archive/issuereport/update",
		updateissuereportattributes: "api/admin/issuereports/archive/issuereport/updateAttributes",
		updateissuereportcategory: "api/admin/issuereports/archive/categories/update",
		updateworkorder: "api/admin/issuereports/workorders/update",
	},
	issuereports:{
		createissuereport: "api/issuereports/create",
		deletefile: "api/issuereports/deletefile/{id}",
		getfilteredissuereportsarchive: "api/issuereports/filteredarchive",
		getissuereport: "api/issuereports/archive/{id}",
		getissuereportcategories: "api/issuereports/categories",
		getissuereportfilteroptions: "api/issuereports/archivefilteroptions",
		getissuereportsarchive: "api/issuereports/archive",
		getissuereportsarchivehistory: "api/issuereports/archivehistory",
		getissuereportsbyvehicleid: "api/issuereports/issuereport/{vehicleid}",
		getissuereportsbyvehicleidandcategoryid: "api/issuereports/issuereport/{vehicleid}/{issuereportcategoryid}",
		getissuereportsgroupedbyvehiclesandbycustomerid: "api/issuereports/archive/grouped",
		getissuereportsoverview: "api/issuereports/overview",
		getpagedissuereportsarchive: "api/issuereports/pagedarchive",
		getvehiclelist: "api/issuereports/vehicles/list",
		uploadfile: "api/issuereports/uploadfile",
	},
	learningadmin:{
		addattendeetoexam: "api/admin/learning/attendees/add",
		downloadlegacypdf: "api/admin/learning/examresult/details/downloadlegacypdf/{id}",
		getattendeestableforexam: "api/admin/learning/attendeesforexam/{id}",
		getexamresultbyid: "api/admin/learning/examresult/{id}",
		getexamresultdetailsbyid: "api/admin/learning/examresult/details/{id}",
		getexamresultslonglist: "api/admin/learning/examresultslonglist",
		getexamresultsshortlist: "api/admin/learning/examresultshortlist/{limit}",
		getexamsettings: "api/admin/learning/getexamsettings/{id}",
		getexamsummaries: "api/admin/learning/examsummaries",
		getexamsummariesstatus: "api/admin/learning/examsummariesstatus/{id}",
		getexamsummary: "api/admin/learning/examsummary/{id}",
		getuserstoadd: "api/admin/learning/exam/{id}/users/search",
		removeattendeefromexam: "api/admin/learning/attendees/remove",
		sendexamremindernotifications: "api/admin/learning/exam/sendremindernotifications",
		sendexamreminderstoattendees: "api/admin/learning/exam/sendreminders/{customerExamId}",
		sendremindertoattendee: "api/admin/learning/exam/sendreminder/{userExaminationId}/{userId}",
		updateexaminationsettings: "api/admin/learning/examsettings/update",
	},
	learning:{
		getassignedexaminationdetails: "api/learning/exams/assigned/{id}",
		getassignedexaminations: "api/learning/exams/assigned",
		getfinishedexamresultsummary: "api/learning/exams/assigned/finished/{id}",
		getmanager: "api/learning/manager",
		getpassedresultsshortlist: "api/learning/results/passed/shortlist",
		submitanswers: "api/learning/exams/assigned/submit",
	},
	map:{
		getdevicedetails: "api/map/devices/details/{deviceId}",
		getdevicelist: "api/map/devices/list",
		getdevicelist2: "api/map/devices/list2",
		getdevicepositions: "api/map/devices/positions",
		getdevicestate: "api/map/devices/state/{deviceId}",
	},
	newsadmin:{
		addarticle: "api/news/admin/article",
		deletearticle: "api/news/admin/article/{id}",
		getarticle: "api/news/admin/article/{id}",
		getcustomer: "api/news/admin/customer",
		listarticles: "api/news/admin/list",
		updatearticle: "api/news/admin/article",
		uploadattachment: "api/news/admin/uploadattachment",
	},
	news:{
		getarticle: "api/news/article/{id}",
		getattachment: "api/news/article/attachment/{id}",
		getattachmentthumbnailbyid: "api/news/article/attachment/getattachmentthumbnailbyid",
		getnewslatest: "api/news/latestshort",
		listarticles: "api/news/list",
	},
	payslip:{
		downloadpayslip: "api/payslip/download/{salaryPeriodId}",
		listpayslips: "api/payslip/list",
	},
	planning:{
		acceptassignment: "api/planning/currentassignment/accept",
		accepttidrapport: "api/planning/currenttimereport/accept",
		getassignment: "api/planning/assignment/{date}",
		getassignments: "api/planning/assignments/{date}",
		getcurrentassignment: "api/planning/currentassignment",
		getcurrenttimereport: "api/planning/currenttimereport",
		getdetailedecodriving: "api/planning/ecodriving/{date}",
		getecodriving: "api/planning/ecodriving",
		getschedule: "api/planning/schedule/{year}/{month}",
		linktoken: "api/planning/linktoken",
	},
	reporting:{
		addreporttemplate: "api/reporting/reporttemplate/add",
		deletereporttemplate: "api/reporting/reporttemplate/{id}",
		getavailablereporttemplates: "api/reporting/reports/availablereports",
		getcontractlistdistinct: "api/reporting/contract/list",
		getemptyreporttemplatetemplate: "api/reporting/reporttemplates/empty",
		getreportresultbytemplateid: "api/reporting/reports/results/{templateId}",
		getreportresultbytemplateidandinterval: "api/reporting/reports/results/interval",
		getreporttemplatebyid: "api/reporting/reporttemplates/edit/{id}",
		getreporttemplates: "api/reporting/reporttemplates/list",
		getsubcontractlistdistinct: "api/reporting/subcontract/list",
		getuserbkyreport: "api/reporting/bkyreport",
		getusersbyrole: "api/reporting/getusersbyrole/{feature}",
		updatereporttemplate: "api/reporting/reporttemplate",
	},
	systemadmincustomers:{
		addcompany: "api/systemadmin/customers/companies/add",
		addcustomer: "api/systemadmin/customers/customers/add",
		addcustomercustomrole: "api/systemadmin/customers/customers/role/add",
		adduser: "api/systemadmin/customers/users/add",
		archiveusers: "api/systemadmin/customers/users/archive",
		checkdepartmentconflicts: "api/systemadmin/customers/companies/checkdepartmentconflicts",
		checkifcustomeralreadyexist: "api/systemadmin/customers/customer/checkifcustomerexist/{customerName}",
		checkifusernamealreadyexist: "api/systemadmin/customers/customer/checkifusernameexist/{userName}",
		deletecompany: "api/systemadmin/customers/companies/delete/{id}",
		deletecustomer: "api/systemadmin/customers/customers/delete/{id}",
		deletecustomercustomrole: "api/systemadmin/customers/customers/role/delete/{id}",
		deleteuser: "api/systemadmin/customers/users/delete/{id}",
		getbpltypes: "api/systemadmin/customers/user/bpltypes/{companyId}",
		getcompanieswithbplinstance: "api/systemadmin/customers/users/companieswithbplinstance/{customerId}",
		getcompanybyid: "api/systemadmin/customers/companies/get/{id}",
		getcustomerbyid: "api/systemadmin/customers/customers/get/{id}",
		getcustomercustomrolebyid: "api/systemadmin/customers/customers/getrole/{id}",
		getcustomercustomroles: "api/systemadmin/customers/customers/getroles/{customerid}",
		getcustomerdeviationsettings: "api/systemadmin/customers/getdeviationsettings/{customerId}",
		getcustomerexaminations: "api/systemadmin/customers/learning/customerexaminations/{customerId}",
		getcustomerexaminationsempty: "api/systemadmin/customers/customer/customerexaminationsempty",
		getcustomerlogobyname: "api/systemadmin/customers/customers/getcustomerlogobyname",
		getcustomerreporttemplates: "api/systemadmin/customers/vehicleregistry/customerreporttemplates/{customerId}",
		getcustomerreporttemplatesempty: "api/systemadmin/customers/learning/customerreporttemplatesempty",
		getcustomerusers: "api/systemadmin/customers/customers/get/{id}/users",
		getdisabledusers: "api/systemadmin/customers/users/disabled/{customerId}",
		getemptycustomer: "api/systemadmin/customers/customers/emptycustomer",
		getemptyuser: "api/systemadmin/customers/users/emptyuser/{id}",
		getuserbyid: "api/systemadmin/customers/users/get/{id}",
		getuserbysearch: "api/systemadmin/customers/customers/{searchparam}",
		getusersselectlistformanagerdropdown: "api/systemadmin/customers/customers/get/{id}/users/searchmanagers",
		getusersselectlistformanagerdropdownedit: "api/systemadmin/customers/customers/get/{id}/users/searchmanagersedit/{userId}",
		importfordonskontrollissuereportsfromcsv: "api/systemadmin/customers/issuereports/import/create/csv/{customerId}",
		listcustomers: "api/systemadmin/customers/customers/list",
		passwordreset: "api/systemadmin/customers/users/resetpassword/{id}",
		updatecompany: "api/systemadmin/customers/companies/update",
		updatecustomer: "api/systemadmin/customers/customers/update",
		updatecustomercustomrole: "api/systemadmin/customers/customers/role/update",
		updateuser: "api/systemadmin/customers/users/update",
		uploadcustomerlogo: "api/systemadmin/customers/customers/uploadcustomerlogo",
		uploaduserimportcreateusersfile: "api/systemadmin/customers/users/import/create/csv/{customerId}",
		uploaduserlegacyexamsfile: "api/systemadmin/customers/users/import/legacyexams/csv/{customerId}",
		validateiscustomernameavailable: "api/systemadmin/customers/customers/validate/iscustomernameavailable",
	},
	systemadmindeviceregistry:{
		adddevice: "api/deviceregistry/admin/device/create",
		addequipment: "api/deviceregistry/admin/equipment/create",
		addstorage: "api/deviceregistry/admin/storage/create",
		addtechnicalpackage: "api/deviceregistry/admin/technicalpackage/create",
		deleteequipment: "api/deviceregistry/admin/equipment/delete/{id}",
		deletetechnicalpackage: "api/deviceregistry/admin/technicalpackage/delete/{id}",
		getdashboarddata: "api/deviceregistry/admin/devices/dashboard",
		getdashboardequipmentcunters: "api/deviceregistry/admin/equipment/summary",
		getdevicebyid: "api/deviceregistry/admin/device/{id}",
		getequipmentbycustomer: "api/deviceregistry/admin/equipment/customer/{id}",
		getequipmentbyid: "api/deviceregistry/admin/equipment/{id}",
		getequipmentbytype: "api/deviceregistry/admin/equipment/type/{id}",
		getequipmentstatuses: "api/deviceregistry/admin/equipment/statuses",
		getstoragebycustomer: "api/deviceregistry/admin/storage/customer/{id}",
		getstoragebyid: "api/deviceregistry/admin/storage/{id}",
		gettechnicalpackagebyid: "api/deviceregistry/admin/technicalpackage/{id}",
		gettechnicalpackageequipmenttype: "api/deviceregistry/admin/technicalpackage/equipmenttype/list",
		gettechnicalpackagelinkedlist: "api/deviceregistry/admin/technicalpackage/equipmenttypes/list",
		listcompanies: "api/deviceregistry/admin/companies/list",
		listdevices: "api/deviceregistry/admin/device/list",
		listdevicesbytype: "api/deviceregistry/admin/device/type/{id}",
		listequipments: "api/deviceregistry/admin/equipment/list",
		listequipmentsnotconnectedtodevice: "api/deviceregistry/admin/equipment/notconnected/list",
		listequipmenttypes: "api/deviceregistry/admin/equipment/type/list",
		listexternaldeviceregistryconfigurations: "api/deviceregistry/admin/externaldeviceregistry/configurations/{deviceTypeId}",
		listexternaldeviceregistrydevicetypes: "api/deviceregistry/admin/externaldeviceregistry/devicetypes",
		liststorages: "api/deviceregistry/admin/storage/list",
		listsystemevents: "api/deviceregistry/admin/systemevents/list",
		listtechnicalpackage: "api/deviceregistry/admin/technicalpackage/list",
		updatedevice: "api/deviceregistry/admin/device/update",
		updateequipment: "api/deviceregistry/admin/equipment/update",
		updatestorage: "api/deviceregistry/admin/storage/update",
		updatetechnicalpackage: "api/deviceregistry/admin/technicalpackage/update",
	},
	systemadmindevtesting:{
		sendnotifications: "api/systemadmin/testing/customfields/sendnotifications",
	},
	systemadminlearning:{
		getexamdetails: "api/systemadmin/learning/details/{id}",
		getexamsummaries: "api/systemadmin/learning/summary",
	},
	systemadminsystem:{
		geteventtypeswithstatusanddeliverymethod: "api/systemadmin/system/eventstypes/mine",
		gettoplatestevents: "api/systemadmin/system/events/latest",
		subscribetoeventtype: "api/systemadmin/system/events/subscribe",
		unsubscribetoeventtype: "api/systemadmin/system/events/unsubscribe",
	},
	test:{
		bkycheckanswer: "api/test/bkycheckanswer",
		bkycheckquestion: "api/test/bkycheckquestion",
		createfile: "api/test/uploadfile",
		getbadrequest: "api/test/badrequest",
		getbadrequestnoresponsedata: "api/test/badrequestnoresponsedata",
		getexception: "api/test/exception",
		getok: "api/test/ok",
		getunauthorized: "api/test/unauthorized",
		getvehiclefiltertest: "api/test/vehiclefiltertest",
	},
	usercustomfieldsadmin:{
		createusercustomfield: "api/admin/usercustomfields/create",
		createusercustomfieldcategory: "api/admin/usercustomfields/categories/create",
		getactivecustomfieldcategoriesbycustomerid: "api/admin/usercustomfields/categories/listactive",
		getcustomfieldcategoriesbycustomerid: "api/admin/usercustomfields/categories/list",
		getcustomfieldcategorybyid: "api/admin/usercustomfields/categories/{id}",
		getusercustomfieldbycustomerid: "api/admin/usercustomfields/list",
		getusercustomfieldbyid: "api/admin/usercustomfields/get/{id}",
		getusercustomfieldformvalues: "api/admin/usercustomfields/user/{userId}/formvalues",
		updateusercustomfield: "api/admin/usercustomfields/update",
		updateusercustomfieldcategory: "api/admin/usercustomfields/categories/update",
		upsertusercustomfieldvalues: "api/admin/usercustomfields/values/upsert",
	},
	usersettings:{
		changepassword: "api/user/settings/passwordchange",
	},
	util:{
		checkpasswordstrength: "api/util/checkpasswordstrength",
		getpasswordsuggestion: "api/util/getpasswordsuggestion",
	},
	vehiclealarm:{
		getresponsibleusersforvehiclealarmeditresponsibledropdown: "api/vehicleregistry/vehicles/alarms/responsibleusers/{vehicleAlarmId}",
		getresponsibleusersforvehiclealarmnotificationdropdown: "api/vehicleregistry/vehicles/alarms/responsibleusersnotification",
		getvehiclealarm: "api/vehicleregistry/vehicles/alarms",
		getvehiclealarmbyid: "api/vehicleregistry/vehicles/alarms/{id}",
		updatevehiclealarmbyid: "api/vehicleregistry/vehicles/alarms/update",
	},
	vehicleexpense:{
		createvehicleexpense: "api/vehicleregistry/expenses/create",
		deletevehicleexpense: "api/vehicleregistry/expenses/delete/{id}",
		getvehicleexpensebyid: "api/vehicleregistry/expenses/get/{id}",
		getvehicleexpensesbyvehicleid: "api/vehicleregistry/expenses/vehicle/{vehicleId}/list",
		updatevehicleexpense: "api/vehicleregistry/expenses/update",
	},
	vehicleregistryadmin:{
		addcontract: "api/vehicleregistry/admin/contract/add",
		addcustomfield: "api/vehicleregistry/admin/customfields/add",
		addvehicle: "api/vehicleregistry/admin/vehicles/add",
		createvehiclealarmnotification: "api/vehicleregistry/admin/settings/vehiclealarmnotification/add",
		deletecustomfieldgroup: "api/vehicleregistry/admin/customfields/groups/delete/{customFieldGroupId}",
		deletevehiclealarmnotification: "api/vehicleregistry/admin/settings/vehiclealarmnotification/{id}",
		deletevehicleattachment: "api/vehicleregistry/admin/attachments/{id}",
		getavailablemainpropellant: "api/vehicleregistry/admin/vehicles/mainpropellant",
		getcontractbyid: "api/vehicleregistry/admin/contract/edit/{id}",
		getcontractlist: "api/vehicleregistry/admin/contract/list",
		getcustomfieldbyid: "api/vehicleregistry/admin/customfields/getitem/{id}",
		getcustomfieldgroupbyid: "api/vehicleregistry/admin/customfields/groups/{id}",
		getcustomfieldgroups: "api/vehicleregistry/admin/customfields/groups/list",
		getdatetimefields: "api/vehicleregistry/admin/customfields/datetimeFields",
		getimporttedrows: "api/vehicleregistry/admin/refueldata/import/{page}/{pagesize}/{sortby}",
		getnumberfields: "api/vehicleregistry/admin/customfields/numberFields",
		getuserstoassign: "api/vehicleregistry/admin/customfields/users",
		getvehiclealarmnotificationsbycustomerid: "api/vehicleregistry/admin/settings/vehiclealarmnotification",
		getvehiclebyid: "api/vehicleregistry/admin/vehicles/edit/{id}",
		getvehicledetailsbyorgnr: "api/vehicleregistry/admin/vehicles/vehicledetailsbyorgnr",
		importcontract: "api/vehicleregistry/admin/contract/import",
		importrefueldata: "api/vehicleregistry/admin/refueldata/import",
		importvehicles: "api/vehicleregistry/admin/vehicles/import",
		importvtrvehicles: "api/vehicleregistry/admin/vehicles/importvtrvehicles",
		listactivecustomfieldnames: "api/vehicleregistry/admin/customfields/listactivenames",
		listcustomfields: "api/vehicleregistry/admin/customfields/list",
		listpagedcontractrows: "api/vehicleregistry/admin/contract/import/{page}/{pagesize}/{sortby}",
		updatecontract: "api/vehicleregistry/admin/contract/update",
		updatecustomfield: "api/vehicleregistry/admin/customfields/update",
		updatecustomfieldgroupsinvehicle: "api/vehicleregistry/admin/customfields/groups/vehicle/updategroups",
		updatevehicle: "api/vehicleregistry/admin/vehicles/update",
		updatevehiclealarmnotification: "api/vehicleregistry/admin/settings/vehiclealarmnotification/update",
		upsertcustomfieldgroup: "api/vehicleregistry/admin/customfields/groups/upsert",
		upsertvehicleattachment: "api/vehicleregistry/admin/attachments/upsert",
		validateimportcontract: "api/vehicleregistry/admin/contract/validate/import",
		validateimportrefueldata: "api/vehicleregistry/admin/refueldata/validate/import",
		validateimportvehicles: "api/vehicleregistry/admin/vehicles/validate/import",
	},
	vehicleregistrychecks:{
		approveservice: "api/vehicleregistry/checks/service/approve",
		createcarworkshop: "api/vehicleregistry/checks/carworkshop/create",
		createvehiclecheckhistory: "api/vehicleregistry/checks/createvehiclecheckhistory",
		deletecarworkshop: "api/vehicleregistry/checks/carworkshop/delete",
		getactivecompanycarworkshops: "api/vehicleregistry/checks/carworkshop/listactive",
		getcarworkshop: "api/vehicleregistry/checks/carworkshop/{id}",
		getcompanycarworkshops: "api/vehicleregistry/checks/carworkshop/list",
		getdetailedvehiclecheckhistorybycustomer: "api/vehicleregistry/checks/history/detailedlist",
		getvehiclecheckhistorybycustomer: "api/vehicleregistry/checks/history/list",
		getvehiclecheckhistorybyvehicle: "api/vehicleregistry/checks/vehicle/{id}/history/list",
		getvehiclechecksbycustomer: "api/vehicleregistry/checks/list",
		getvehiclechecksbyvehicleid: "api/vehicleregistry/checks/vehicle/{id}/list",
		updatecarworkshop: "api/vehicleregistry/checks/carworkshop/update",
		updateinspectionbooking: "api/vehicleregistry/checks/inspection/booking/update",
		updatevehiclecheckshistory: "api/vehicleregistry/checks/history/update",
	},
	vehicleregistry:{
		changeeventstatus: "api/vehicleregistry/calender/changestatus",
		getattachment: "api/vehicleregistry/attachments/{id}",
		getdashboard: "api/vehicleregistry/dashboard",
		getevents: "api/vehicleregistry/calendar/getevents/{start}/{stop}",
		getfiltered: "api/vehicleregistry/getfiltered",
		getiotdetailsbyvehicleid: "api/vehicleregistry/vehicles/iotDetails/{id}",
		getiotodometerstatus: "api/vehicleregistry/vehicles/{id}/iotOdometerStatus",
		getiotodometerstatusbatch: "api/vehicleregistry/vehicles/iotOdometerStatusBatch",
		getlastupdatefromtransportagency: "api/vehicleregistry/vehicles/importvtr",
		getuserreporttemplates: "api/vehicleregistry/getuserreporttemplates",
		getvehicleactivecustomfieldgroupids: "api/vehicleregistry/customfields/activegroupids/{vehicleId}",
		getvehicleattachmentsbyvehicleid: "api/vehicleregistry/vehicles/{vehicleId}/attachments/list",
		getvehicledetailsbyid: "api/vehicleregistry/vehicles/details/{id}",
		getvehicledetailsbyregnr: "api/vehicleregistry/vehicles/vehicledetailsbyregnr/{regnr}",
		getvehicledetailsbyregnrlist: "api/vehicleregistry/vehicles/vehicledetailsbyregnrlist",
		getvehicleformvalues: "api/vehicleregistry/customfields/formvalues/{vehicleId}",
		getvehicleformvaluesfilteredbygroups: "api/vehicleregistry/customfields/groupfilteredformvalues/{vehicleId}",
		getvehiclelist: "api/vehicleregistry/vehicles/list",
		getvtrfordashboard: "api/vehicleregistry/dashboard/vtr",
		updatevehicleodometer: "api/vehicleregistry/vehicles/odometer",
	},
	violationadmin:{
		getavailablecompanies: "api/violationadmin/getavailablecompanies",
		getavailabledepartments: "api/violationadmin/getavailabledepartments/{companyId}",
		getcompany: "api/violationadmin/getcompany/{id}",
		getuserstoassign: "api/violationadmin/getuserstoassign/{departmentid}",
		getviolationdrivingtypessettings: "api/violationadmin/getdrivingtypessettings/{companyid}",
		getviolationemailsettings: "api/violationadmin/getemailsettings/{departmentid}",
		postviolationdrivingtypesetting: "api/violationadmin/postviolationdrivingtypesetting",
		postviolationemailsetting: "api/violationadmin/postviolationemailsetting",
		uploadidhafile: "api/violationadmin/uploadidha",
	},
	violation:{
		get: "api/violation/get",
		getbyid: "api/violation/details/{id}",
		getdrivingtypes: "api/violation/drivingtypes/{companyid}",
		updateviolation: "api/violation/details/update",
	},
}
